import {
  DataProvider,
  Filtering,
  Sorting,
  useCurrentUser,
} from '@qualio/ui-components';
import { useMemo } from 'react';
import { backendTaskApi } from '../../../../api/backendTask';
import { DocumentStatus } from '../../../../api/model/document';
import { ExportDocumentListButton } from '../../Export/ExportDocumentListButton/ExportDocumentListButton';
import { FOR_TRAINING_FILTER } from '../TrainingFilter';
import { useLibraryFilterDefinitions } from './hooks/useLibraryFilterDefinitions';

type LibraryFilterDefinitions = ReturnType<typeof useLibraryFilterDefinitions>;

export const ExportButton = () => {
  const currentUser = useCurrentUser();
  const { data, isLoading } = DataProvider.useDataProvider();
  const { filters, searchTerm } =
    Filtering.useFiltering<LibraryFilterDefinitions>();
  const sorting = Sorting.useSortingMaybe();

  const owner = filters.owner?.value;
  const tags = (filters.filteringTag?.value ?? []).filter(
    (tag): tag is string => tag !== null,
  );
  const templates = (filters.filteringTemplates?.value ?? []).filter(
    (template): template is string => template !== null,
  );
  const forTraining = filters.filter_by?.value === FOR_TRAINING_FILTER;

  const sortingValue = useMemo(() => {
    if (!sorting?.column) {
      return null;
    }
    return sorting.descending ? `-${sorting.column}` : sorting.column;
  }, [sorting?.column, sorting?.descending]);

  return (
    <ExportDocumentListButton
      currentUser={currentUser}
      isDisabled={isLoading || !data || data.length === 0}
      searchQuery={searchTerm || null}
      sortingValue={sortingValue}
      statusFilters={[DocumentStatus.Effective]}
      tagsFilter={tags}
      templatesFilter={templates}
      ownerFilter={owner ? Number(owner) : null}
      exportTaskMethod={
        forTraining
          ? backendTaskApi.startUserTrainingDocumentsExportTask
          : backendTaskApi.startAllDocumentsExportTask
      }
    />
  );
};
